@if (useTimeline()) {
  <!-- Vista compacta: timeline vertical (móvil o columna angosta) -->
  <div class="flow-timeline">
    @for (step of resolvedSteps(); track step.id; let last = $last) {
      <div class="flow-timeline-node"
           [class.is-done]="step.state === 'ok'"
           [class.is-pending]="step.state === 'pending'"
           [class.is-rejected]="step.state === 'rejected'"
           [class.is-last]="last">
        
        <!-- Riel con nodo e indicador -->
        <div class="flow-timeline-rail">
          <div class="flow-timeline-dot">
            @if (step.state === 'ok') {
              <i class="fas fa-check"></i>
            } @else if (step.state === 'rejected') {
              <i class="fas fa-times"></i>
            } @else {
              <i class="fas fa-clock"></i>
            }
          </div>
          @if (!last) {
            <div class="flow-timeline-line"></div>
          }
        </div>

        <!-- Contenido del hito -->
        <div class="flow-timeline-content">
          <div class="d-flex align-items-center justify-content-between gap-2">
            <span class="flow-step-title fw-bold text-uppercase"
                  [class.text-success]="step.state === 'ok'"
                  [class.text-danger]="step.state === 'rejected'"
                  [class.text-secondary]="step.state === 'pending'">
              <i [class]="step.icon + ' me-1'"
                 [class.text-success]="step.state === 'ok'"
                 [class.text-danger]="step.state === 'rejected'"
                 [class.text-secondary]="step.state === 'pending'"></i>{{ step.title }}
            </span>
            <span class="badge border" [ngClass]="step.statusStyle">
              {{ step.statusLabel }}
            </span>
          </div>

          @if (step.state === 'ok' || step.state === 'rejected') {
            @if (step.actorName || step.actorMail) {
              <div class="flow-step-actor mt-1">
                <strong>{{ step.actorName || step.actorMail }}</strong>
                @if (step.actorRole && step.actorName) {
                  <span class="text-muted"> · {{ step.actorRole }}</span>
                }
              </div>
            }
            @if (step.decidedAt) {
              <div class="flow-step-meta text-muted">
                <i class="far fa-calendar-alt me-1"></i>{{ step.decidedAt | date: 'dd/MM/yyyy HH:mm' }}
                @if (step.channel) {
                  <span class="ms-1">· {{ step.channel }}</span>
                }
              </div>
            }
            @if (step.votoNumber) {
              <div class="flow-step-meta text-muted">
                Nº voto: <strong class="text-body">{{ step.votoNumber }}</strong>
              </div>
            }
            @if (step.amount != null) {
              <div class="flow-step-meta text-muted">
                Monto: <strong class="text-body">{{ step.amount | currency:'CLP':'$':'1.0-0' }}</strong>
              </div>
            }
            @if (step.hasDocument) {
              <div class="mt-1">
                <button type="button" class="btn btn-outline-primary btn-sm py-0.5 px-2.5 d-inline-flex align-items-center gap-1"
                        (click)="onViewDoc(step)">
                  <i class="fas fa-file-pdf"></i>
                  <span>{{ step.documentLabel || 'Ver Documento' }}</span>
                </button>
              </div>
            }
            @if (step.rejectionReason) {
              <div class="alert alert-danger py-1 px-2 small mb-0 mt-1">
                <strong>Motivo:</strong> {{ step.rejectionReason }}
              </div>
            }
          } @else {
            <div class="flow-step-pending text-muted mt-0.5">
              {{ step.pendingMessage }}
            </div>
            @if (step.token) {
              <div class="flow-step-token d-flex align-items-center gap-2 mt-1 flex-wrap">
                <span class="small text-muted">Token:</span>
                <code class="px-1 py-0.5 bg-light border rounded small">{{ step.tokenDisplay }}</code>
                <button type="button" class="btn btn-outline-secondary btn-sm py-0 px-2" (click)="copyToken(step.token)">
                  {{ tokenCopied() ? 'Copiado' : 'Copiar' }}
                </button>
                @if (canResendToken()) {
                  <button type="button" class="btn btn-outline-primary btn-sm py-0 px-2"
                    (click)="resendToken()" [disabled]="tokenResending()">
                    {{ tokenResending() ? 'Enviando…' : 'Reenviar' }}
                  </button>
                }
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
} @else {
  <!-- Vista Desktop: Tabla Ejecutiva de Trazabilidad BPM -->
  <div class="table-responsive">
    <table class="table table-hover align-middle mb-0">
      <thead class="border-bottom">
        <tr>
          <th scope="col" class="text-uppercase small fw-bold text-muted py-2.5 ps-3" style="min-width: 170px;">Paso / Rol</th>
          <th scope="col" class="text-uppercase small fw-bold text-muted py-2.5" style="min-width: 220px;">Responsable</th>
          <th scope="col" class="text-uppercase small fw-bold text-muted py-2.5" style="min-width: 130px;">Estado</th>
          <th scope="col" class="text-uppercase small fw-bold text-muted py-2.5" style="min-width: 160px;">Fecha y Canal</th>
          <th scope="col" class="text-uppercase small fw-bold text-muted py-2.5" style="min-width: 140px;">Detalle</th>
          <th scope="col" class="text-uppercase small fw-bold text-muted py-2.5 text-center pe-3" style="width: 120px;">Documento</th>
        </tr>
      </thead>
      <tbody>
        @for (step of resolvedSteps(); track step.id) {
          <tr [class.table-light-subtle]="step.state === 'pending'">
            <td class="ps-3">
              <div class="d-flex align-items-center gap-2">
                <div class="bpm-role-icon rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                  <i [class]="step.icon"
                     [class.text-success]="step.state === 'ok'"
                     [class.text-danger]="step.state === 'rejected'"
                     [class.text-secondary]="step.state !== 'ok' && step.state !== 'rejected'"></i>
                </div>
                <span class="fw-semibold text-body small">{{ step.title }}</span>
              </div>
            </td>

            <td>
              @if (step.actorName || step.actorMail) {
                <div class="small fw-semibold text-body">{{ step.actorName || step.actorMail }}</div>
                @if (step.actorRole && step.actorName) {
                  <div class="small text-muted">{{ step.actorRole }}</div>
                }
              } @else {
                <span class="small text-muted fst-italic">{{ step.pendingMessage || 'Pendiente' }}</span>
              }
            </td>

            <td>
              <span class="badge border" [ngClass]="step.statusStyle">
                {{ step.statusLabel }}
              </span>
            </td>

            <td>
              @if (step.decidedAt) {
                <div class="small text-body">{{ step.decidedAt | date: 'dd/MM/yyyy HH:mm' }}</div>
                @if (step.channel) {
                  <div class="small text-muted">Canal: {{ step.channel }}</div>
                }
              } @else {
                <span class="small text-muted">—</span>
              }
            </td>

            <td>
              @if (step.votoNumber) {
                <div class="small text-muted">Nº Voto: <strong class="text-body">{{ step.votoNumber }}</strong></div>
              }
              @if (step.amount != null) {
                <div class="small text-muted">Monto: <strong class="text-body">{{ step.amount | currency:'CLP':'$':'1.0-0' }}</strong></div>
              }
              @if (step.token) {
                <div class="d-flex align-items-center gap-1">
                  <code class="small px-1 py-0.5 bg-light border rounded">{{ step.tokenDisplay }}</code>
                  <button type="button" class="btn btn-outline-secondary btn-sm py-0 px-2" (click)="copyToken(step.token)">
                    {{ tokenCopied() ? 'Copiado' : 'Copiar' }}
                  </button>
                  @if (canResendToken()) {
                    <button type="button" class="btn btn-outline-primary btn-sm py-0 px-2"
                      (click)="resendToken()" [disabled]="tokenResending()">
                      {{ tokenResending() ? 'Enviando…' : 'Reenviar' }}
                    </button>
                  }
                </div>
              }
              @if (step.rejectionReason) {
                <div class="text-danger small" title="{{ step.rejectionReason }}">
                  <i class="fas fa-exclamation-circle me-1"></i>{{ step.rejectionReason }}
                </div>
              }
              @if (!step.votoNumber && step.amount == null && !step.token && !step.rejectionReason) {
                <span class="small text-muted">—</span>
              }
            </td>

            <td class="text-center pe-3">
              @if (step.hasDocument) {
                <button type="button" class="btn btn-outline-primary btn-sm px-2.5 py-1 text-nowrap" (click)="onViewDoc(step)" title="Ver Documento">
                  <i class="fas fa-eye me-1"></i>Ver
                </button>
              } @else {
                <span class="text-muted small">—</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
